"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizes = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32
};

function StorageregionsMultitoneOutline(_ref) {
  var className = _ref.className,
      inheritFontColor = _ref.inheritFontColor,
      inheritFontSize = _ref.inheritFontSize,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      muted = _ref.muted,
      clickable = _ref.clickable,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "inheritFontColor", "inheritFontSize", "size", "width", "height", "disabled", "onClick", "muted", "clickable", "children"]);

  var classes = ['orion-icons-svg-base'];

  if (inheritFontColor) {
    classes.push('orion-icons-svg-current-clr');
  }

  if (muted) {
    classes.push('orion-icons-svg-muted');
  }

  if (!disabled && (clickable || typeof onClick === 'function')) {
    classes.push('orion-icons-svg-clickable');
  }

  if (disabled) {
    classes.push('orion-icons-svg-disabled');
  }

  classes.push(className);
  var finalWidth = width || sizes[size];
  var finalHeight = height || sizes[size];

  if (inheritFontSize) {
    finalWidth = finalHeight = '1em';
  }

  var finalClass = classes.filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: finalWidth,
    height: finalHeight,
    fill: "none",
    viewBox: "0 0 16 16",
    color: "currentColor",
    className: finalClass,
    onClick: !disabled ? onClick : null
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__storageregions-multitone-outline__clip0_13467_184)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 8,
    cy: 8.012,
    fill: "#CCE5FF",
    rx: 4,
    ry: 4.003
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M2.837 10.698a.653.653 0 01-.088-.008A3.25 3.25 0 01.532 9.287a3.092 3.092 0 01-.44-2.483c.2-.795.76-1.775 2.273-2.139.04-1.12.46-3.638 3.309-4.513.982-.284 3.084-.328 4.486 1.323.887-.292 2.25-.332 3.12.96.468.695.6 1.539.368 2.306 1.115.276 2.15 1.016 2.33 2.44.207 1.654-1.035 3.258-2.71 3.501a.6.6 0 01-.171-1.187c1.043-.152 1.818-1.143 1.69-2.167-.164-1.303-1.586-1.487-2.018-1.511l-.364-.02-.18-.352a.629.629 0 01.085-.66c.052-.064.095-.144.135-.236.196-.455.132-1.007-.16-1.443-.69-1.027-1.905-.44-2.04-.368l-.476.248-.3-.44C8.234.716 6.105 1.283 6.017 1.307c-2.597.796-2.469 3.478-2.445 3.782a.641.641 0 01-.555.68c-1.323.176-1.638.843-1.758 1.327A1.876 1.876 0 001.53 8.62c.32.48.827.8 1.395.883a.594.594 0 01.503.68.597.597 0 01-.591.515z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M8.007 16l-.424-.424c-1.914-1.915-3.687-3.998-3.687-6.249a4.11 4.11 0 014.103-4.106 4.11 4.11 0 014.103 4.106c0 2.263-1.766 4.338-3.672 6.25L8.007 16zm-.004-9.58a2.908 2.908 0 00-2.905 2.907c0 1.66 1.41 3.419 2.913 4.97 1.554-1.6 2.896-3.295 2.896-4.97a2.913 2.913 0 00-2.904-2.906z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M8.003 11.546a2.113 2.113 0 01-2.11-2.11c0-1.164.947-2.112 2.11-2.112 1.162 0 2.11.948 2.11 2.111a2.116 2.116 0 01-2.11 2.111zm0-3.022a.91.91 0 100 1.821.91.91 0 000-1.821z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__storageregions-multitone-outline__clip0_13467_184"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H16V16H0z"
  }))));
}

StorageregionsMultitoneOutline.propTypes = {
  size: _propTypes["default"].string,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  className: _propTypes["default"].string,
  inheritFontColor: _propTypes["default"].bool,
  inheritFontSize: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  clickable: _propTypes["default"].bool,
  muted: _propTypes["default"].bool
};
StorageregionsMultitoneOutline.defaultProps = {
  size: 'sm',
  className: '',
  inheritFontColor: false,
  inheritFontSize: false,
  disabled: false,
  onClick: null,
  clickable: false,
  muted: true
};
var _default = StorageregionsMultitoneOutline;
exports["default"] = _default;